const BaseComponent = require('base/base-component');

class noticeTabs2 extends BaseComponent {
  constructor () {
    super({
      events: {
        'click .tab': 'switchTab'
      }
    });
  }
  init () {
    super.init();
    this.$more = this.$el.find('.to-more');
    this.$tabs = this.$el.find('.nav .tab');
    this.$countBox = this.$el.find('.purchase-count');
    // 初始化 more href属性
    this.$tabs.eq(0).trigger('click');
  }
  switchTab (e) {
    const $target = $(e.target || e.srcElement);
    const index = $target.index();
    // url切换
    this.$more.prop('href', $target.data('path'));

    const $content = $target.closest('.nav').siblings('.content').find('ul');
    $target.addClass('active').siblings('h4').removeClass('active');
    $content.removeClass('show');
    $content.eq(index).addClass('show');
  }
}
module.exports = noticeTabs2;
